<template>
  <Primitive
    :as="props.as"
    :class="cn(assigneesWrapperVariants({ size }), props.class)"
  >
    <div v-if="assignees.length" class="flex items-center gap-2 relative">
      <AvatarGroup
        :users="assignees"
        :size="avatarSizes[size]"
        :maxAvatars="maxAvatars"
      />

      <div
        v-if="showNames && computedNames"
        class="text-utility-gray-700 truncate max-w-[220px]"
      >
        {{ computedNames }}
      </div>
    </div>
    <div v-else class="flex items-center gap-2 text-placeholder">
      <Tooltip
        :title="$t('components.assignees.unassigned')"
        side="bottom"
        class="!w-fit"
        triggerAs="span"
        disableHoverableContent
        ignoreNonKeyboardFocus
      >
        <Avatar :size="avatarSizes[size]" />
      </Tooltip>
      <span v-if="showNames" class="truncate max-w-[120px]">
        {{ $t("components.assignees.unassigned") }}
      </span>
    </div>
  </Primitive>
</template>

<script setup>
import { Primitive } from "radix-vue";
import { computed } from "vue";
import { cn } from "@/Utils/cn";
import { assigneesWrapperVariants, avatarSizes } from ".";
import { Avatar, AvatarGroup } from "@/SharedComponents/Avatars";
import { Tooltip } from "@/SharedComponents/Tooltips";

const props = defineProps({
  as: { type: String, default: "div" },
  assignees: { type: Array, required: false, default: () => [] },
  size: { type: String, required: false, default: "md" },
  showNames: { type: Boolean, required: false, default: true },
  maxAvatars: { type: Number, required: false, default: 2 },
});

const assignees = computed(() => {
  if (!props.assignees) return [];
  return props.assignees;
});

const computedNames = computed(() => {
  if (!props.assignees) return null;
  if (props.assignees.length === 1) {
    return `${
      props.assignees[0].firstname
    } ${props.assignees[0].lastname.substring(0, 1)}.`;
  }
  if (props.assignees.length === 2) {
    return `${props.assignees[0].firstname} & ${props.assignees[1].firstname}`;
  }
  return null;
});
</script>
